module.exports = __webpack_public_path__ + "Roboto-Medium.894a2ede85a483bf9bed.ttf";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Medium.ttf
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Medium.ttf
// module chunks = styles